export default {
  relics: 'Relikte',
  museum: 'Museum',
  battery: 'Reliktbatterie',
  glyph: {
    title: 'Glyphe: {0}',
    noLevel: 'Füge ein Relikt mit dieser Glyphe einem Sockel hinzu, um die Stufe dieser Glyphe zu erhöhen',
    speedOvercap: 'Du hast mehr Glyphen zugewiesen als nötig, wodurch die Stufe dieser Glyphe x{0} schneller steigt',
    speedBonus: 'Du hast {0} Bonus-Glyphen von anderen Sockeln, wodurch die Stufe dieser Glyphe x{1} schneller steigt',
    dust: 'Staub',
    clay: 'Lehm',
    heat: 'Hitze',
    wood: 'Holz',
    flow: 'Fluss',
    stone: 'Stein',
    spike: 'Stachel',
    dream: 'Traum',
    clover: 'Kleeblatt',
    rain: 'Regen',
    sun: 'Sonne',
    cloud: 'Wolke',
    blossom: 'Blüte',
    leaf: 'Blatt',
    paper: 'Papier',
    book: 'Buch',
    coin: 'Münze',
    card: 'Karte',
  },
  pedestal: {
    modify: 'Sockel verändern',
    modifyDescription: 'Das Verändern eines Sockels setzt den Fortschritt der aktuellen Stufe für alle Glyphen zurück, denke also genau nach, bevor du Änderungen vornimmst',
    unsavedChanges: 'Änderungen an Sockeln werden erst angewendet, wenn du auf "{0}" klickst',
  },

  torch: {
    name: 'Fackel',
    active: 'Ausleuchten',
    description: 'Tiefeneinschränkungen entfernen',
    formula: 'Wähle eine Tiefe. Für den Rest des Durchlaufs sind alle Rohstoffe auf dieser Tiefe verfügbar (mit 50% Einkommen), solange die Mindesttiefe erreicht ist',
  },
  purpleHeart: {name: 'Lila Herz'},
  dustyBook: {name: 'Verstaubtes Buch'},
  rottenLeaf: {name: 'Verrottetes Blatt'},
  stonepiercer: {
    name: 'Steinspalter',
    active: 'Erschüttern',
    description: 'Maximale Zerbrechungen',
    formula: 'Jede Tiefe erhält die maximale Menge an Zerbrechungen aller Tiefen darunter. Erhalte dadurch anfallendes Salpeter ({0})',
  },
  consolationPrize: {name: 'Trostpreis'},
  prettyLamp: {name: 'Schöne Lampe'},
  museumKey: {name: 'Museumsschlüssel'},
  ribbon: {name: 'Schleife'},
  copier: {name: 'Kopierer'},
  deckOfCards: {name: 'Kartendeck'},
  chessboard: {name: 'Schachbrett'},
  iridiscentFlower: {name: 'Schillernde Blume'},
  scienceBook: {name: 'Wissenschaftsbuch'},
  hugeDiamond: {name: 'Riesiger Diamant'},

  excavator: {
    name: 'Bagger',
    active: 'Ausbuddeln',
    description: 'Erstatte {0} Schrott',
    formula: 'Setze deine Schrottmenge auf die höchste Schrottmenge in diesem Durchlauf ({0})',
  },
  redCard: {name: 'Rote Karte'},
  briefcase: {name: 'Aktentasche'},
  strangePlant: {name: 'Seltsame Pflanze'},
  beneficialVirus: {name: 'Gutartiges Virus'},
  shapeCollection: {
    name: 'Formensammlung',
    active: 'KI-Kunst',
    description: 'Sammle {0} Formen automatisch',
    formula: 'Verwende {0} Motivation (bis zu {1}), um automatisch {2} Formen zu sammeln. Das beeinflusst das aktuelle Formengitter nicht'
  },
  stonePillar: {name: 'Steinsäule'},
  fieryRuby: {name: 'Feuriger Rubin'},

  notebook: {
    name: 'Notizbuch',
    active: 'Hausaufgaben abschreiben',
    description: 'Erhalte {0} Gesamtpunkte',
    formula: 'Erhöhe deine Gesamtpunkte um {0}, oder benutze einen Prüfungspass, um stattdessen {1} Gesamtpunkte zu erhalten'
  },

  friendlyBat: {
    name: 'Freundliche Fledermaus',
    active: 'Echoortung',
    description: 'Erhalte {0} Schrott',
    formula: 'Abhängig von der höchsten Schrottmenge insgesamt ({0}) und 20 Minuten Schrotteinkommen bei der tiefsten abgeschlossenen Tiefe ({1})',
  },
  honeyPot: {
    name: 'Honigtopf',
    active: 'Bienenschwarm',
    description: 'Fülle dein Harz auf',
    formula: 'Erhalte so viel Harz wie deine Harz-Kapazität ({0})',
  },

  mudBrick: {name: 'Matschziegel'},
  sapling: {name: 'Setzling'},
  keychain: {
    name: 'Schlüsselanhänger',
    active: 'Steuersammlung',
    description: 'Erhalte {0} Goldmünzen',
    formula: 'Abhängig von der höchsten Goldmünzenmenge insgesamt ({0}) und 10 Minuten Steuern bei maximaler Nahrungsproduktion ({1})',
  },
  screwdriver: {name: 'Schraubenzieher'},

  energyDrink: {
    name: 'Energydrink',
    active: 'Voller Energie',
    description: 'Aktive Ausrüstungseffekte bereit machen',
    formula: 'Setze die Abklingzeit aller aktiven Ausrüstungseffekte zurück ({0}) und starte den aktuellen Kampf neu'
  },

  lightningRod: {
    name: 'Blitzableiter',
    active: 'Gewitter',
    description: 'Maximale Pflegeeffekte',
    formula: 'Verbrauche {0} Regenwasser ({1}% von der manuell benötigten Menge), um alle Pflegeeffekte zu maximieren',
  },
  goldenCarrot: {name: 'Goldene Karotte'},
  goldenApple: {name: 'Goldener Apfel'},
  popcorn: {name: 'Popcorn'},
  roseQuartz: {name: 'Rosenquartz'},
  goldenSeed: {name: 'Goldene Saat'},

  lightbulb: {name: 'Glühbirne'},
  fishbowl: {name: 'Fischglas'},
  pencil: {name: 'Bleistift'},
  smallBrush: {
    name: 'Kleiner Pinsel',
    active: 'Besondere Form malen',
    description: 'Erstelle eine besondere Form',
  },
  strangePills: {name: 'Seltsame Pillen'},
  printingPress: {name: 'Druckpresse'},

  diamondPickaxe: {name: 'Diamantspitzhacke'},
  diamondHammer: {name: 'Diamanthammer'},
  diamondSword: {name: 'Diamantschwert'},
  diamondShovel: {name: 'Diamantschaufel'},
  diamondBrush: {name: 'Diamantpinsel'},
  diamondPillar: {name: 'Diamantsäule'},

  tinfoilHat: {name: 'Aluhut'},
  cupOfWater: {name: 'Wasserbecher'},
  combatStrategy: {name: 'Kampfstrategie'},
  hundredDollarBill: {name: '100-Dollar-Note'},
  hotAirBalloon: {name: 'Heißluftballon'},
  largeClover: {name: 'Großes Kleeblatt'},
  eightBall: {name: 'Schwarze 8'},
  youngPig: {name: 'Junges Ferkel'},
  silverHorseshoe: {name: 'Silbernes Hufeisen'},
  bronzeTools: {name: 'Bronzewerkzeug'},
  minersHat: {name: 'Bergmannshelm'},
  dictionary: {name: 'Lexikon'},
  expertTools: {name: 'Expertenwerkzeug'},
  bloodBag: {name: 'Blutbeutel'},
  geode: {name: 'Geode'},
  birthdayCake: {name: 'Geburtstagskuchen'},
  colorfulFlower: {name: 'Farbenfrohe Blume'},
  heatingBulb: {name: 'Heizlampe'},
  trashCan: {name: 'Mülleimer'},
  suitcase: {name: 'Koffer'},
  tropicalTent: {name: 'Tropisches Zelt'},
  fruitBasket: {name: 'Obstkorb'},
  massiveGrain: {name: 'Riesiges Getreide'},
  enchantedBottle: {name: 'Verzauberte Flasche'},
  moneyGift: {name: 'Geldgeschenk'},
  frozenCarrot: {name: 'Gefrorene Karotte'},
};
